
  
  // export const basicauth={
  //   username: "info@seobix@bumppy@goseo",
  //   password: "goseo@bumppy@seobix@info",
  
  // }
  

  export const basicauth={
    username: process.env.REACT_APP_LOGIN_USERNAME,
    password: process.env.REACT_APP_LOGIN_PASSWORD,
  
  }
  // export const apibasicauth={
  //   username: "BUMPPY_SSO_SgLjvARJ5LbX",
  //   password: "tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq",
  
  // }
export const apibasicauth = {
    username: process.env.REACT_APP_API_USERNAME,
    password: process.env.REACT_APP_API_PASSWORD,
  };

// Bumppy blog APIs use the same server-side API credentials. Keep these in the
// environment files rather than exposing the Basic Auth secret in source.
export const basicauthblog = {
  username: process.env.REACT_APP_API_USERNAME,
  password: process.env.REACT_APP_API_PASSWORD,
};

export const imageUploadApiKey =
  "a5440fb487c090cd95d405291787dc15ed77fa7e5c91e64fcb708b375fc6f492";
export const imageUploadBasicAuth = {
  username: "b42c8d805be73be5c01739fd5934c61c",
  password: "73be5c01739fd5934c61c4567829hbdjdj",
};
